import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
  name: 'htmlSanitize',
  standalone: true,
})
export class HtmlSanitizePipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);


  transform(uncleanStr: string): SafeHtml {
    const sanitizedStr: string | null = this.sanitizer.sanitize(
      SecurityContext.HTML,
      uncleanStr,
    );
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedStr ?? '');
  }
}
